import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { ParametroSistemaModel } from '../../models/parametro-sistema.model';
import { BreadcrumbService } from '../../../../services/breadcrumb.service';
import { SeguridadService } from '../../services/seguridad.service';
import { CifrarDataService } from '../../../../services/cifrar-data.service';
import { GlobalsConstants } from '../../../../models/globals-constants.modelo';
import swal from'sweetalert2';

@Component({
  selector: 'app-panel-sistema',
  templateUrl: './panel-sistema.component.html',
  styleUrls: ['./panel-sistema.component.css']
})
export class PanelSistemaComponent implements OnInit, OnDestroy {

  titulo = 'Parametros de Sistema';
  globalConstants: GlobalsConstants = new GlobalsConstants();
  modeloForm: FormGroup;
  subscription$: Subscription;
  modelo: ParametroSistemaModel = new ParametroSistemaModel();

  constructor(private fb: FormBuilder,
              private breadcrumbService: BreadcrumbService,
              private seguridadService: SeguridadService,
              private cifrarDataService: CifrarDataService) {
    this.breadcrumbService.setItems([
      { label: 'Modulo Seguridad' },
      { label: 'Parametro Sistema', routerLink: ['module-se/panel-parametro-sistema'] }
    ]);
  }

  ngOnInit(): void {
    this.onInicializaFormulario();
    this.onObtieneRegistro();
  }

  onInicializaFormulario() {
    this.modeloForm = this.fb.group({ 
      sendEmail : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(5)])),
      sendEmailPasswordOrigen : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(30), Validators.minLength(5)])),
      sendEmailPort : new FormControl(0, Validators.compose([Validators.required,])),
      sendEmailEnabledSSL : new FormControl(false, Validators.compose([Validators.required])),
      sendEmailHost : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(5)])),
      // emailGoogleDrive : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(5)])),
      // emailPassword : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(30), Validators.minLength(3)])),
      diasPresupuesto : new FormControl(0, Validators.compose([Validators.required,])),
      diasCartaFianza : new FormControl(0, Validators.compose([Validators.required,])),
      sendEmailReceptor : new FormControl('', Validators.compose([Validators.required, Validators.maxLength(500), Validators.minLength(5)])),
      });
  }

  onObtieneRegistro() {
    this.subscription$ = new Subscription();
    this.subscription$ = this.seguridadService.getParametroSistemaPorId()
    .subscribe(resp => {
      if (resp) {
        console.log(resp);
        this.modelo = resp;
        this.setRegistroObtenido();
        }
      },
      (error) => {
        swal.fire(this.globalConstants.msgErrorSummary, error.error.resultadoDescripcion ,'error');
      }
    );
  }

  setRegistroObtenido() {
  
    this.modeloForm.controls['sendEmail'].setValue(this.modelo.sendEmail);
    this.modeloForm.controls['sendEmailPasswordOrigen'].setValue(this.cifrarDataService.decrypt(this.modelo.sendEmailPasswordOrigen));
    this.modeloForm.controls['sendEmailPort'].setValue(this.modelo.sendEmailPort);
    this.modeloForm.controls['sendEmailEnabledSSL'].setValue(this.modelo.sendEmailEnabledSSL);
    this.modeloForm.controls['sendEmailHost'].setValue(this.modelo.sendEmailHost);
    // this.modeloForm.controls['emailGoogleDrive'].setValue(this.modelo.emailGoogleDrive);
    // this.modeloForm.controls['emailPassword'].setValue(this.cifrarDataService.decrypt(this.modelo.emailPassword));
    this.modeloForm.controls['diasPresupuesto'].setValue(this.modelo.diasPresupuesto);
    this.modeloForm.controls['diasCartaFianza'].setValue(this.modelo.diasCartaFianza);
    this.modeloForm.controls['sendEmailReceptor'].setValue(this.modelo.sendEmailReceptor);
  }

  onClickSave() {
    this.modelo.sendEmail = this.modeloForm.controls['sendEmail'].value;
    this.modelo.sendEmailPasswordOrigen = this.cifrarDataService.encrypt(this.modeloForm.controls['sendEmailPasswordOrigen'].value);
    this.modelo.sendEmailPort = this.modeloForm.controls['sendEmailPort'].value;
    this.modelo.sendEmailEnabledSSL = this.modeloForm.controls['sendEmailEnabledSSL'].value;
    this.modelo.sendEmailHost = this.modeloForm.controls['sendEmailHost'].value;
   // this.modelo.emailGoogleDrive = this.modeloForm.controls['emailGoogleDrive'].value;
   // this.modelo.emailPassword = this.cifrarDataService.encrypt(this.modeloForm.controls['emailPassword'].value);
   this.modelo.diasPresupuesto = this.modeloForm.controls['diasPresupuesto'].value;
   this.modelo.diasCartaFianza = this.modeloForm.controls['diasCartaFianza'].value;
   this.modelo.sendEmailReceptor = this.modeloForm.controls['sendEmailReceptor'].value;

    this.subscription$ = new Subscription();
    let observ = new Observable();
    if (this.modelo.idParametrosSistema === 0) {
      observ = this.seguridadService.setInsertParametroSistema(this.modelo);
    } else {
      observ = this.seguridadService.setUpdateParametroSistema(this.modelo);
    }
    this.subscription$ = observ
    .subscribe(() =>  {
      swal.fire(this.globalConstants.msgExitoSummary, this.globalConstants.msgExitoDetail , 'success');
    },
      (error) => {
        swal.fire(this.globalConstants.msgErrorSummary, error.error.resultadoDescripcion ,'error');
    });
    
  }

  ngOnDestroy() {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

}
